__turbopack_context__.v({
  "body": "card-module__sgmVNW__body",
  "bodyDescription": "card-module__sgmVNW__bodyDescription",
  "card": "card-module__sgmVNW__card",
  "description": "card-module__sgmVNW__description",
  "footer": "card-module__sgmVNW__footer",
  "footerDescription": "card-module__sgmVNW__footerDescription",
  "header": "card-module__sgmVNW__header",
  "title": "card-module__sgmVNW__title",
});
